import { createApp } from 'vue';
import RafToWebpConverter from '../Components/RafToWebpConverter.vue';

const root = document.getElementById('raf-to-webp-converter');
if (root) {
  createApp(RafToWebpConverter).mount('#raf-to-webp-converter');
}
